module.exports = __webpack_public_path__ + "static/media/anchor.378d1062.jpg";